import * as React from "react";
import { useState, useEffect } from 'react';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
//import Header, Box from '@cloudscape-design/components/header';
import { CustomAppLayout } from '../../layout';
import { useRouter } from '../../router';
import { useStore } from '../../store';
import { useGlobalState } from '../../../context/GlobalStateContext';
import { useStoreAdmin } from '../../../context/useStoreAdmin';
import { Box, CollectionPreferences, Header } from '@cloudscape-design/components';


const pageSize = 20;

export const ConfigUnitsOrderPage = () => {
    const storeAdmin = useStoreAdmin();
    const { setLoading } = useGlobalState();
    const { idPropiedad, setIdPropiedad } = useGlobalState();
    const { JWT, setJWT } = useGlobalState();

    const {
        actions: { makeHelpPanelHandler },
    } = useStore();
    const { navigate } = useRouter();
    const [units, setUnits] = useState<UserUnit[]>([]);

    type UserUnit = {
        idUnidad: string;
        allowDistanceOpenInmueble: number;
        unidad: string;
        quotaMax: string;
        quotaActual: string;
        reqInfoUnidad: number;
        reqInfoTitle: string;
        canHandleGuests: number;
        isBlockUnit: string;
        pendingCount: string;
        users: number;
    };




    // Handle row click to fetch additional data and open the HelpPanel

    const handleRefresh = async () => {
        try {

            setLoading(true);
            const response = await fetch('https://api2.llavemovil.com/routing/v1/default.aspx', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/admin/units/list',
                    'JWT': JWT,

                },
                body: JSON.stringify({
                    units: false,
                    accesses: false,
                    columns: "idUnidad, unidad, allowDistanceOpenInmueble, isBlockUnit, reqInfoUnidad, reqInfoTitle, canHandleGuests, (select count(distinct idControl) from Autorizados where idInmueble=Inmuebles.idInmueble) as users "
                })
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();

            storeAdmin(data);
            // Create a new list with updated 'accesos' field before setting it to state
            setUnits(data.units);

        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        handleRefresh();
    }, []);
    const [preferences, setPreferences] = React.useState({
        pageSize: 10,
        wrapLines: true,
        stickyColumns: { first: 1, last: 0 }
    });
    return (
        <CustomAppLayout
            toolsHide

            contentType="form"
            breadcrumbs={
                <BreadcrumbGroup
                    items={[
                        { text: 'Inicio', href: '#home' },
                        { text: 'Configuración', href: '#config/default' },
                        { text: 'Unidades', href: '#create-transcription-job' },
                    ]}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <>
                    <Header variant='h3'>Ordenamiento de unidades</Header>
                    <CollectionPreferences
                        onConfirm={({ detail }) => console.log(detail)}
                        preferences={preferences}
                        title="Reordenamiento de unidades"
                        confirmLabel="Guardar cambios"
                        contentDisplayPreference={{
                            options: [
                                {
                                    id: "id",
                                    label: "Distribution ID",
                                    alwaysVisible: true
                                },
                                { id: "domainName", label: "Domain name" },
                                {
                                    id: "deliveryMethod",
                                    label: "Delivery method"
                                },
                                { id: "priceClass", label: "Price class" },
                                {
                                    id: "sslCertificate",
                                    label: "SSL certificate"
                                },
                                { id: "origin", label: "Origin" }
                            ]
                        }}
                    />


                </>
            }
        />
    );
};